<template>
	<div class="slide-show">
      <div class="slide-holder" :style="{marginLeft:-100*current+'%'}">
        <div v-for="slide in slides" class="slide" :style="{backgroundImage:`url(${slide.image}?w=1920)`}">
          <div class="fader" :style="styles.fade">
            <div class="content" v-html="slide.title" :style="styles.content">
            </div>
          </div>
        </div>
      </div>
      <div class="controls">
        <div class="prev-btn" @click="prev()">
          <span class="fa fa-angle-left"></span>
        </div>
        <div class="next-btn" @click="next()">
          <span class="fa fa-angle-right"></span>
        </div>
      </div>
    </div>
</template>

<script>
export default {
	props:{
    "slides":{type:Array},
    "styles":{type:Object, default(){return {
      fade:{background:"rgba(0,0,0,0.25)"}
    }}}
  },
  name: 'i-slide-show',
  methods:{
    prev(){
      this.current = this.current-1;
      if(this.current<0){
        this.current = this.slides.length - 1;
      }
      console.log("PREV",this.current);

    },
    next(){
      this.current = this.current+1;
      if(this.current>=this.slides.length){
        this.current=0;
      }
      console.log("NEXT",this.current);
    },
  },
  data () {
    return {
      current:0
    }
  }
}
</script>

<style lang="css" scoped>
.slide-show{
  height:400px;
  overflow: hidden;
}
.slide{
    /*background: url(./img/building/2.webp);*/
    /*background: url(./img/building/1.jpg);*/
    background-size: cover;
    height:400px;
    background-position: center;
    width:12.5%;
    float:left;
}

.slide-holder{
      white-space: nowrap;
      width:800%;
      transition: 0.3s all ease;
}
.next-btn,.prev-btn{
  background:rgba(0,0,0,0.5);
  padding:16px 16px;
  font-size:24px;
  color:white;
  display: inline-block;
  cursor: pointer;
  margin-top:170px;
}
.next-btn:hover,.prev-btn:hover{
  background:rgba(0,0,0,0.2);
  
  

}
.next-btn{
  float:right;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.prev-btn{
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;

}

.controls{
    height: 400px;
    position: relative;
    display: block;
    width: 100%;
    top: -100%;
    z-index: 9;
}
.fader{
  height:400px;
  background: rgba(0,0,0,0.25);
      display: table;
    width: 100%;
    transition: 0.3s all ease;
}
.slide .content{
  vertical-align: middle;
  text-align: center;
  font-size:42px;
  color:white;
      height: 400px;
    display: table-cell;
    width: 100%;
    white-space: normal;
    padding:0 15%;
    text-transform: uppercase;
    background: rgba(0,0,0,0.22)
}

.slide-show:hover .fader{
  /*background: rgba(0,0,0,0.75);*/
}
</style>